import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'products-page_via_impression-view';
/**
 * Fired on PDP load when an impression id query param is present
 */
export function trackProductsPageViaImpressionView(productToken, impressionId_string) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { productToken, impressionId_string },
    });
}
